<template>

  <v-container>
    <v-layout align-start justify-start row>
      <v-flex xs12 md10>
        <h2>チャレンジシート</h2>
      </v-flex>
      <v-flex xs2 md1>
        <v-btn color="cyan" class="white--text" @click="openPrintPage">
          <v-icon color="white">print</v-icon>印刷ページを開く
        </v-btn>
      </v-flex>
    </v-layout>
    <v-alert :value="true" color="info" icon="info" outline>
      クリックして上司に承認をお願いしてください。
      <v-btn @click="dialog=true">承認のお願い</v-btn>
    </v-alert>
    <v-dialog v-model="dialog" max-width="80%">
      <edit-rater
        @closeDialog="dialog=false"
        v-if="dialog"
        :userName="sheet.name"
        :permissionDic="permissionDic"
      />
    </v-dialog>

    <v-card v-if="sheet != null && target != null">
      <v-card-text>
        <v-layout align-start justify-start row>
          <v-flex xs12 md10>
            <v-text-field label="スローガン" v-model="sheet.slogan" clearable></v-text-field>
          </v-flex>
          <v-flex xs4 md2>
            <v-btn @click="updateSheet()">保存</v-btn>
          </v-flex>
        </v-layout>
        <v-layout align-start justify-start row>
          <v-flex xs12 sm3>
            <v-text-field
              label="目標設定期間"
              readonly
              :value="getPeriod(target.set_start_date, target.set_end_date)"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 offset-sm1>
            <v-text-field
              label="上司承認期間"
              readonly
              :value="getPeriod(target.ok_start_date, target.ok_end_date)"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm3 offset-sm1>
            <v-text-field
              label="振り返り期間"
              readonly
              :value="getPeriod(target.review_start_date, target.review_end_date)"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <div v-for="plan in sheet.plans" :key="plan.no" :mode="mode">
          <plan :plan="plan" @updatePlan="updateSheet()"/>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import Plan from "@/components/targets/plan.vue";
import EditRater from "@/components/targets/editRater.vue";

import { mapActions, mapGetters } from "vuex";
import { unixtimeToFormattedDate } from "@/utils/datetime.js";

export default {
  components: {
    Plan,
    EditRater
  },
  data() {
    return {
      newPlans: [
        {
          no: 1,
          approve_status: false,
          approve_comment: "",
          self: null,
          rater: null,
          rater_comment: "",
          self_comment: "",
          plan: "",
          method: ""
        },
        {
          no: 2,
          approve_status: false,
          approve_comment: "",
          self: null,
          rater: null,
          rater_comment: "",
          self_comment: "",
          plan: "",
          method: ""
        },
        {
          no: 3,
          approve_status: false,
          approve_comment: "",
          self: null,
          rater: null,
          rater_comment: "",
          self_comment: "",
          plan: "",
          method: ""
        }
      ],
      active: 0,
      dbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("challenge_sheets"),
      dbRefTargets: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("targets"),
      sheet: null,
      target: null,
      dialog: false,
      permissionDic: { rating: "rap9BWtsnF", approving: "apWd2mrSq4" },
      invertedPermissionDic: { rap9BWtsnF: "rating", apWd2mrSq4: "approving" }
    };
  },
  computed: {
    mode() {
      const permission = this.$route.query.p;
      if (this.invertedPermissionDic[permission]) {
        return this.invertedPermissionDic[permission];
      } else {
        return "user";
      }
    },
    permission() {
      const permissions = {
        aprroving: {
          slogan: { write: false },
          plan: { write: false, aprrove: true, rate: false, self_rate: false }
        }
      };
    }
  },
  mounted() {
    console.log(this.$route.query);
    this.reloadItems();
  },
  methods: {
    async reloadItems() {
      this.changeLoadingState(true);
      try {
        const sheet = await this.dbRef.doc(this.$route.params.sheet_id).get();
        if (!sheet.exists) {
          throw { code: "target/sheet-not-found" };
        }
        this.sheet = { ...sheet.data(), id: sheet.id };

        const target = await this.dbRefTargets.doc(this.sheet.target_id).get();
        this.target = { ...target.data(), id: target.id };


        this.changeLoadingState(false);
      } catch (e) {
        console.error(e);
        this.changeLoadingState(false);
      }
    },
    getPeriod(start, end) {
      return (
        unixtimeToFormattedDate(start) + " ~ " + unixtimeToFormattedDate(end)
      );
    },
    updateSheet() {
      this.dbRef
        .doc(this.$route.params.sheet_id)
        .set(this.sheet, { merge: true })
        .then(doc => {
          console.log();
        })
        .catch(e => {
          console.error(e);
        });
    },
    openPrintPage() {
            let routeData = this.$router.resolve({ name: 'print_target' ,params: { company_id: this.$route.params.company_id, sheet_id:this.$route.params.sheet_id}})
            window.open(routeData.href, '_blank');
        },
    ...mapActions("app", ["changeLoadingState"])
  }
};
</script>

<style lang="scss" scoped>
.point {
  padding: 0px 5px;
}
.point-label {
  margin-top: 18px;
}
</style>


